import STORE from 'store.singleton';

const getState = STORE.getState.bind(STORE);

export default getState;
